import { Injectable } from '@angular/core'
import { environment } from '@environments/environment'
import { ContentUnitNavigationItem } from '../models/content-unit-navigation-item.model'
import { AbstractContentSidebarStateService } from './abstract-content-sidebar-state.service'

@Injectable({
  providedIn: 'root'
})
export class ContentUnitStateService extends AbstractContentSidebarStateService<ContentUnitNavigationItem> {
  protected override readonly apiUrl = environment.cuApiUrl
  protected override readonly subsystemName = 'Content Unit List Loading'
  protected override readonly errorDescription = 'Could not load the list of Content Units.'
}
